module.exports = __webpack_public_path__ + "img/job_top.8b2e8433.png";